import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ChangeDetectorRef } from '@angular/core';
import { SharedDataService } from 'src/app/services/sharedDataService.service';
interface MenuItem {
  title: string;
  icon?: string;
  children?: MenuItem[];
  route?: string;
  link?: string;
}

type MenuItemDesktop = MenuItemLink | MenuItemSubmenu;

interface BaseMenuItem {
  type: 'item' | 'submenu';
  title: string;
  selectedKey: boolean;
  link: string;
  pageKey: string;
}
interface MenuItemLink extends BaseMenuItem {
  type: 'item';
  disabled?: boolean;
}

interface MenuItemSubmenu extends BaseMenuItem {
  type: 'submenu';
  highlightClass?: string;
  groups: MenuGroup[];
}

interface MenuGroup {
  title: string;
  icon: string;
  items: SubMenuItem[];
}

interface SubMenuItem {
  title: string;
  selectedKey: boolean;
  pageKey: string,
  link: string;
}
@Component({
  selector: 'official-website-header',
  templateUrl: './official-website-header.component.html',
  styleUrls: ['./official-website-header.component.less']
})
export class OfficialWebsiteHeaderComponent implements OnInit {
  isVisible = false;
  currentLevel: 'main' | 'secondary' | 'tertiary' = 'main';
  menuStack: { title: string, items: MenuItem[] }[] = [{ title: '', items: [] }];
  itemSelectedKey = '';
  submenuOpen = false;
  pollingIntervalId: any;
  isDealerPortal: boolean = false;
  menuItems: MenuItem[] = [
    {
      title: '首页',
      route: '/gb/cn',
    },
    {
      title: '配件目录',
      route: '/gb/cn/parts',
    },
    {
      title: '诊断设备',
      route: '',
    },
    {
      title: 'HEADER_WORKSHOP_SERVICE',
      children: [
        { title: '概览', route: '/gb/cn/services' },
        {
          title: '技术培训及支持',
          children: [
            { title: '汽车维修技术培训', route: '/gb/cn/services/training-solutions/service-training' },
            { title: '培训中心', route: '/gb/cn/services/service-solutions/equipment-services' }
          ]
        },
        {
          title: '维修站生态体系',
          children: [
            {
              title: 'FRC博世车联',
              link: 'https://www.boschcarservice.com.cn/'
            },
            { title: 'BDx博世柴油系统服务网络', route: '/gb/cn/services/workshop-concepts/bosch-diesel-repair-network' },
            {
              title: 'BSS博世乘用车配件优选', route: '/gb/cn/services/workshop-concepts/bss-parts-selection-store'
            },
            {
              title: 'CV Plan博世商用车增值计划', route: '/gb/cn/services/workshop-concepts/cv-plan'
            }
          ]
        },
        {
          title: '增值计划',
          children: [
            {
              title: 'eXtra易加网', route: '/gb/cn/services/programs/extra-rewards'
            }
          ]
        }
      ]
    },
    {
      title: '下载中心',
      route: '/gb/cn/documents',
    },
  ];

  menuItemsDesktop: MenuItemDesktop[] = [
    {
      type: 'item',
      title: '首页',
      selectedKey: true,
      disabled: false,
      link: '/gb/cn',
      pageKey: 'homePage'
    },
    // {
    //   type: 'item',
    //   title: '汽车配件',
    //   selectedKey: false,
    //   link: 'https://catalogue.bosch-trading.com.cn/cn',
    //   pageKey: 'ecatalog'
    // },
    {
      type: 'item',
      title: '配件目录',
      selectedKey: false,
      disabled: false,
      link: '/gb/cn/parts',
      pageKey: 'parts'
    },
    {
      type: 'item',
      title: '诊断设备',
      selectedKey: false,
      disabled: true,
      link: '',
      pageKey: ''
    },
    {
      type: 'submenu',
      title: 'HEADER_WORKSHOP_SERVICE',
      selectedKey: false,
      link: '/gb/cn/services',
      pageKey: 'serivces',
      highlightClass: 'highlighted',
      groups: []
    },
    {
      type: 'item',
      title: '新闻中心',
      selectedKey: false,
      disabled: false,
      link: '/gb/cn/news',
      pageKey: 'news'
    },
    {
      type: 'item',
      title: '下载中心',
      selectedKey: true,
      link: '/gb/cn/documents',
      pageKey: 'documents'
    },
  ];

  menuItemGroup = [
    {
      title: '技术培训及支持',
      icon: 'assets/official-website/service-agent.svg',
      items: [
        {
          title: '汽车维修技术培训',
          selectedKey: false,
          pageKey: 'service-training',
          link: '/gb/cn/services/training-solutions/service-training/'
        },
        {
          title: '培训中心',
          selectedKey: false,
          pageKey: 'equipment-services',
          link: '/gb/cn/services/service-solutions/equipment-services'
        }
      ]
    },
    {
      title: '维修站生态体系',
      icon: 'assets/official-website/team.svg',
      items: [
        {
          title: 'FRC博世车联',
          selectedKey: false,
          pageKey: 'frc',
          link: 'https://www.boschcarservice.com.cn/'
        },
        {
          title: 'BDx博世柴油系统服务网络',
          selectedKey: false,
          pageKey: 'diesel-repair',
          link: '/gb/cn/services/workshop-concepts/bosch-diesel-repair-network'
        },
        {
          title: 'BSS博世乘用车配件优选',
          selectedKey: false,
          pageKey: 'parts-selection',
          link: '/gb/cn/services/workshop-concepts/bss-parts-selection-store'
        },
        {
          title: 'CV Plan博世商用车增值计划',
          selectedKey: false,
          pageKey: 'cv-plan',
          link: '/gb/cn/services/workshop-concepts/cv-plan'
        }
      ]
    },
    {
      title: '增值计划',
      icon: 'assets/official-website/truck-car-motorcycle.svg',
      items: [
        {
          title: 'eXtra易加网',
          selectedKey: false,
          pageKey: 'extra-rewards',
          link: '/gb/cn/services/programs/extra-rewards'
        }
      ]
    },
  ];


  constructor(
    private router: Router,
    private cdr: ChangeDetectorRef,
    private sharedData: SharedDataService,
  ) {
    this.sharedData.currentData.subscribe(data => {
      this.isDealerPortal = data.isDealerPortal;
    });
  }

  ngOnInit(): void {
    this.setSelectedItem();
  }

  goSingleKeyId(): void {
    let client_id = environment.clientID;
    let redirect_uri = environment.redirectUrl;
    window.location.href = `${environment.singleKeyIdToprofile}/auth/connect/authorize?client_id=${client_id}&redirect_uri=${redirect_uri}&scope=openid+profile+email+phone&response_type=code&state=fdGWLdczhU&nonce=atlKOwlYwT&culture=zh-CN`;
  }

  userLogin(): void {
    this.sharedData.updateData({ isDealerPortal: window.location.href.includes("Dealerportal") });
    const url = window.location.href;
    if (url.includes("Salesportal")) {
      localStorage.setItem("portalName", 'Salesportal');
      this.onSSOLogin();
      console.log("URL包含Salesportal");
    } else {
      console.log("URL不包含Salesportal");
      localStorage.setItem("portalName", 'Dealerportal');
      this.goSingleKeyId();
    }
  }

  //SSO login
  onSSOLogin() {
    window.location.href = `https://login.microsoftonline.com/0ae51e19-07c8-4e4b-bb6d-648ee58410f4/oauth2/v2.0/authorize?client_id=0bcd975c-9900-438d-8a0a-c93e7d299803&response_type=code&redirect_uri=${location.origin}/Salesportal/gettoken&scope=openid email profile`;
  }

  goHome(path: any): void {
    this.openPage(path, 'homePage')
    this.isVisible = false;
    this.menuStack = [{ title: '', items: [] }];
  }
  openMenu(): void {
    this.isVisible = true;
    this.currentLevel = 'main';
    this.menuStack = [{ title: '', items: this.menuItems }];
  }

  closeMenu(): void {
    this.isVisible = false;
    this.menuStack = [{ title: '', items: [] }];
  }

  navigateTo(menuItem: MenuItem): void {
    if (menuItem.route) {
      this.router.navigateByUrl(menuItem.route);
      console.log(`Navigating to ${menuItem.route}`);
      this.closeMenu();
      if (environment.production) {
        (window as any).dataLayer.push({
          event: 'dp_ow_navigation_click',
          from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
          event_type: '',
          event_name: 'navigation click',
          portal_name: "OfficialWebsite",
          event_content: menuItem.route,
        });
      }
      return;
    }

    if (menuItem.children && menuItem.children.length > 0) {
      this.menuStack.push({
        title: menuItem.title,
        items: menuItem.children
      });

      if (this.menuStack.length === 2) {
        this.currentLevel = 'secondary';
      } else if (this.menuStack.length === 3) {
        this.currentLevel = 'tertiary';
      }
    }
  }

  goBack(): void {
    if (this.menuStack.length > 1) {
      this.menuStack.pop();

      if (this.menuStack.length === 1) {
        this.currentLevel = 'main';
      } else if (this.menuStack.length === 2) {
        this.currentLevel = 'secondary';
      }
    } else {
      this.closeMenu();
    }
  }

  getCurrentMenu() {
    return this.menuStack[this.menuStack.length - 1];
  }

  openPage(url: string, menu: string): void {
    if (environment.production) {
      (window as any).dataLayer.push({
        event: 'dp_ow_navigation_click',
        from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
        event_type: '',
        event_name: 'navigation click',
        portal_name: "OfficialWebsite",
        event_content: url,
      });
    }
    if (url.includes('http')) {
      this.router.navigateByUrl('gb/cn/new-page');
      window.open(url, '_blank')
      return;
    }
    this.router.navigateByUrl(url);
    this.menuItemsDesktop.forEach(item => {
      item.selectedKey = false;
      if (item.type === 'submenu' && item.groups) {
        item.groups.forEach(group => {
          group.items.forEach(subItem => {
            subItem.selectedKey = false;
          });
        });
      }
    });
    const targetItem = this.menuItemsDesktop.find(item => item.pageKey === menu);
    if (targetItem) {
      targetItem.selectedKey = true;
    }
  }

  openSubPage(pageKey: string): void {
    if (environment.production) {
      (window as any).dataLayer.push({
        event: 'dp_ow_navigation_click',
        from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
        event_type: '',
        event_name: 'navigation click',
        portal_name: "OfficialWebsite",
        event_content: pageKey,
      });
    }
    if (pageKey === 'frc') {
      this.router.navigateByUrl('gb/cn/new-page');
      window.open('https://www.boschcarservice.com.cn/', '_blank')
      return;
    }
    this.menuItemsDesktop.forEach(item => {
      item.selectedKey = false;
      if (item.type === 'submenu' && item.groups) {
        item.selectedKey = true;
        item.groups.forEach(group => {
          group.items.forEach(subItem => {
            subItem.selectedKey = false;
            if (pageKey === subItem.pageKey) {
              subItem.selectedKey = true;
            }
          });
        });
      }
    });
  }

  onMenuMouseEnter(): void {
    this.ensureOverlayAndWaitForClass('ow-header-menu');
  }

  onMenuMouseLeave(): void {
    clearInterval(this.pollingIntervalId);
  }

  ensureOverlayAndWaitForClass(className: string): void {
    this.pollingIntervalId = setInterval(() => {
      const overlays = document.querySelectorAll('.cdk-overlay-pane');
      if (overlays.length > 1) {
        const matched = Array.from(overlays).find(el => el.classList.contains(className));
        if (matched) {
          clearInterval(this.pollingIntervalId);
          this.menuItemsDesktop.forEach(item => {
            if (item.type === "submenu") {
              item.groups = this.menuItemGroup;
            }
          });
        } else {
          overlays.forEach(pane => {
            if (!pane.classList.contains('ow-header-menu')) {
              pane.classList.add('ow-header-menu');
            }
          });
        }
      }
    }, 50);
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event: PopStateEvent) {
    this.setSelectedItem();
  }

  getFirstAfterGbCn(path: string): string | null {
    const match = path.match(/\/gb\/cn\/([^/]+)/);
    return match ? match[1] : null;
  }

  setSelectedItem() {
    this.menuItemsDesktop.forEach(item => {
      const pathValueAfterGbCn = this.getFirstAfterGbCn(item.link);
      const windowPath = this.getFirstAfterGbCn(window.location.pathname);
      if (pathValueAfterGbCn === windowPath) {
        item.selectedKey = true;
      } else {
        item.selectedKey = false;
      }
      if (item.type === 'submenu' && item.groups) {
        item.groups.forEach(group => {
          group.items.forEach(subItem => {
            const lastPathValue = window.location.pathname.split('/').pop();
            if (lastPathValue === subItem.link.split('/').pop()) {
              subItem.selectedKey = true;
            } else {
              subItem.selectedKey = false;
            }
          });
        });
      }
    });
  }
}

